"use strict";

import { AppDispatcher } from 'Dispatcher';
import { TableToolBarConstants } from "Constants/Table/TableToolBarConstants";
export function toolbarTableFormSetTableElem(tableInstance, formUUID) {
  AppDispatcher.dispatch({
    actionType: TableToolBarConstants.TOOLBAR_TABLE_FORM_SET_TABLE_ELEM,
    tableInstance: tableInstance,
    formUUID: formUUID
  });
}
export function loadButtonsData(dataFormButtons, dataContextMenu) {
  AppDispatcher.dispatch({
    actionType: TableToolBarConstants.TOOLBAR_TABLE_FORM_LOAD_BUTTONS_DATA,
    dataFormButtons: dataFormButtons,
    dataContextMenu: dataContextMenu
  });
}
export function toolbarTableFormButtonsDisabling(buttons, disabled, formUUID) {
  AppDispatcher.asyncDispatch({
    actionType: TableToolBarConstants.TOOLBAR_TABLE_FORM_TABLE_BUTTONS_DISABLING,
    buttons: buttons,
    disabled: disabled,
    formUUID: formUUID
  });
}
export function tbSetDefaultButtonsState(formUUID) {
  AppDispatcher.dispatch({
    actionType: TableToolBarConstants.TOOLBAR_TABLE_SET_DEFAULT_STATE,
    formUUID: formUUID
  });
}
export function toolbarTableFormSetRowKey(currentRowKey, formUUID) {
  AppDispatcher.asyncDispatch({
    actionType: TableToolBarConstants.TOOLBAR_TABLE_FORM_SET_ROW_KEY,
    formUUID: formUUID,
    currentRowKey: currentRowKey
  });
}
export function toolbarTableKeyboardEvents(formUUID, event) {
  AppDispatcher.dispatch({
    actionType: TableToolBarConstants.TOOLBAR_TABLE_KEY_EVENT,
    formUUID: formUUID,
    event: event
  });
}
export function toolbarTableSetObjectName(formUUID, objectName) {
  AppDispatcher.dispatch({
    actionType: TableToolBarConstants.TOOLBAR_TABLE_SET_OBJECT_NAME,
    formUUID: formUUID,
    objectName: objectName
  });
}
export function ttbResetTableSettings(options) {
  AppDispatcher.dispatch({
    actionType: TableToolBarConstants.TOOLBAR_TABLE_RESET_TABLE_SETTINGS,
    options: options
  });
}
export function tbEditBtnClicked(options) {
  AppDispatcher.dispatch({
    actionType: TableToolBarConstants.TOOLBAR_TABLE_EDIT_BTN_CLICKED,
    options: options
  });
}
export function tbShowFilterBtnClicked(options) {
  AppDispatcher.dispatch({
    actionType: TableToolBarConstants.TOOLBAR_TABLE_SHOW_FILTER_BTN_CLICKED,
    options: options
  });
}
export function tbSelectionBtnClicked(options) {
  AppDispatcher.dispatch({
    actionType: TableToolBarConstants.TOOLBAR_TABLE_SELECTION_BTN_CLICKED,
    options: options
  });
}
export function tbShowColumnChooserBtnClicked(options) {
  AppDispatcher.dispatch({
    actionType: TableToolBarConstants.TOOLBAR_TABLE_COLUMN_CHOOSER_BTN_CLICKED,
    options: options
  });
}
export function tbShowFilterModalClicked(options) {
  AppDispatcher.dispatch({
    actionType: TableToolBarConstants.TOOLBAR_TABLE_SHOW_FILTER_MODAL_CLICKED,
    options: options
  });
}
export function tbDeleteRowsClicked(options) {
  AppDispatcher.dispatch({
    actionType: TableToolBarConstants.TOOLBAR_TABLE_DELETE_ROWS_CLICKED,
    options: options
  });
}
export function tbGotoClicked(options) {
  AppDispatcher.dispatch({
    actionType: TableToolBarConstants.TOOLBAR_TABLE_GOTO_CLICKED,
    options: options
  });
}
export function tbReportClicked(options) {
  AppDispatcher.dispatch({
    actionType: TableToolBarConstants.TOOLBAR_TABLE_REPORT_CLICKED,
    options: options
  });
}
export function tbUpdateFormUUID(formUUID, nextFormUUID) {
  AppDispatcher.dispatch({
    actionType: TableToolBarConstants.TOOLBAR_TABLE_UPDATE_FORM_UUID,
    formUUID: formUUID,
    nextFormUUID: nextFormUUID
  });
}
export function tbClearQuickFilters(options) {
  AppDispatcher.dispatch({
    actionType: TableToolBarConstants.TOOLBAR_TABLE_CLEAR_QUICK_FILTERS,
    options: options
  });
}
export function tbButtonsToggleAttrs(buttons, attr, formUUID) {
  AppDispatcher.asyncDispatch({
    actionType: TableToolBarConstants.TOOLBAR_TABLE_TOGGLE_ATTRS,
    buttons: buttons,
    attr: attr,
    formUUID: formUUID
  });
}
export function tbSetReadOnlyMode(formUUID, mode) {
  AppDispatcher.asyncDispatch({
    actionType: TableToolBarConstants.TOOLBAR_TABLE_READONLY,
    formUUID: formUUID,
    mode: mode
  });
}